import {config} from "./config";
import {request} from "./request";


function createElePromotion(data, cb, fail_cb) {
    request.get.call(this, config.apiList.createElePromotion, data, cb, fail_cb)
}

function createOrUpdateConfig(data, cb, fail_cb) {
    request.post.call(this, config.apiList.eleConfigs, data, null, cb, fail_cb)
}

function getEleConfigs(data, cb, fail_cb) {
    request.get.call(this, config.apiList.eleConfigs, data, cb, fail_cb)
}

var eleApi = {
    createElePromotion: createElePromotion,
    createOrUpdateConfig: createOrUpdateConfig,
    getEleConfigs: getEleConfigs,
}

export {eleApi}